import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Check, Copy, RefreshCw } from 'lucide-react';
import { memo, useState } from 'react';
export const LinkSharing = /*#__PURE__*/ memo(function LinkSharing({ linkShare, onToggle, onRegenerate, isLoading }) {
    const [copied, setCopied] = useState(false);
    const handleCopy = async ()=>{
        if (linkShare?.url) {
            await navigator.clipboard.writeText(linkShare.url);
            setCopied(true);
            setTimeout(()=>setCopied(false), 2000);
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-3",
        "data-testid": "link-sharing",
        children: [
            /*#__PURE__*/ _jsxs("label", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        type: "checkbox",
                        checked: linkShare?.enabled ?? false,
                        onChange: (e)=>onToggle(e.target.checked),
                        disabled: isLoading,
                        className: "rounded"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-sm",
                        children: "Anyone with the link can view"
                    })
                ]
            }),
            linkShare?.enabled && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ _jsx("input", {
                                type: "text",
                                value: linkShare.url,
                                readOnly: true,
                                className: "flex-1 px-3 py-2 border border-input rounded-md bg-muted text-sm"
                            }),
                            /*#__PURE__*/ _jsxs("button", {
                                onClick: handleCopy,
                                disabled: isLoading,
                                className: "px-3 py-2 bg-primary text-primary-foreground rounded-md text-sm hover:bg-primary/90 disabled:opacity-50 flex items-center gap-2",
                                title: "Copy link",
                                children: [
                                    copied ? /*#__PURE__*/ _jsx(Check, {
                                        className: "w-4 h-4"
                                    }) : /*#__PURE__*/ _jsx(Copy, {
                                        className: "w-4 h-4"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "hidden sm:inline",
                                        children: "Copy link"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("button", {
                        onClick: onRegenerate,
                        disabled: isLoading,
                        className: "w-full px-3 py-2 border border-input rounded-md text-sm hover:bg-muted disabled:opacity-50 flex items-center justify-center gap-2",
                        children: [
                            /*#__PURE__*/ _jsx(RefreshCw, {
                                className: "w-4 h-4"
                            }),
                            "Regenerate link"
                        ]
                    }),
                    linkShare.expiresAt && /*#__PURE__*/ _jsxs("p", {
                        className: "text-xs text-muted-foreground",
                        children: [
                            "Expires: ",
                            new Date(linkShare.expiresAt).toLocaleDateString()
                        ]
                    })
                ]
            })
        ]
    });
});
